/**
 * Main application entry point.
 *
 * @author Stanislav Kalashnik <sk@infomir.eu>
 * @license GNU GENERAL PUBLIC LICENSE Version 3
 */

'use strict';

var app     = require('mag-app'),
    keys    = require('stb-keys'),
    gettext = require('spa-gettext');

require('./modules/find-index-polyfill');

if ( TARGET === 'android-stb' || TARGET === 'android-app' ) {
    window.removeEventListener('keydown', require('spa-app/lib/events').keydown);
    require('../../../helpers/longpress.js')(app, {code: keys.ok, emitCode: keys.menu});
}


app.intents = {
    osdInput: null,
    osdTv: null
};


// everything is ready
app.once('load', function () {
    if ( TARGET === 'dvb' ) {
        app.provider = core.plugins.dvb;
    } else {
        app.provider = core.plugins.tvBackend;
    }

    gettext.load({name: core.environment.language || 'en'}, function ( error ) {
        var EpgPage = require('./modules/epg-page/index'),
            epg = new EpgPage({
                $node: document.getElementById('pageEpg'),
                apiProvider: app.provider
            });

        epg.addListener('back', function ( item ) {
            app.route(app.pages.main, item);
        });

        if ( error ) {
            // err handler
        }

        // add intent handler to show app on incoming intent
        core.addListener('intent', function ( intent, callback ) { callback(false, {}); });

        app.pages = {
            main: require('./pages/channels'),
            epg: epg
        };


        if ( TARGET === 'dvb' ) {
            app.pages.scanOptions = require('./pages/scan.options');
            app.pages.scanning = require('./pages/scanning');
        }

        app.route(app.pages.main);

    });
});
